import backhoeDozer from "../assets/images/others-attachments/backhoe-dozer.webp";
import frontendLoader from "../assets/images/others-attachments/frontend-loader.webp";
import sugarcaneLoader from "../assets/images/others-attachments/sugarcane-loader.webp";
import telescopicLoader from "../assets/images/others-attachments/telescopic-loader.webp";
import ultraLoader from "../assets/images/others-attachments/ultra-loader.webp";
import v2sugarcane from "../assets/images/others-attachments/v2sugarcane-loader.webp";
import agriseries from "../assets/images/others-attachments/agri_series.webp";
import linupradialloader from "../assets/images/others-attachments/linup-radial-loader.webp";

export const OtherAttachments = [
  {
    id: 1,
    title: "Chargeuse-pelleteuse et bulldozer",
    description:"Les deux sont idéaux pour l'aménagement du terrain, l'excavation, le creusement, le nivellement et la démolition. Les deux fonctionnent bien même sur des sols durs et durs. Les machines ont fait leurs preuves et ont fait leurs preuves. Les machines sont montées sur le site du client et sont compatibles avec 84 modèles de tracteurs.",
    image: backhoeDozer,
  },
  {
    id: 2,
    title: "Chargeur frontal",
    description:"Le chargeur frontal est un accessoire de tracteur qui convient mieux aux applications lourdes dans l'agriculture, la construction et plusieurs segments industriels. Le chargeur est amovible, tout comme les godets du chargeur. Le chargeur est livré avec plus de 40 types d'options de godet spécifiques à l'application qui sont compatibles avec plus de 140 modèles de tracteurs.",
    image: frontendLoader,
  },
  {
    id: 3,
    title: "Chargeur de canne à sucre",
    description:"Comme son nom l'indique, l'ultra chargeur de canne à sucre est idéal pour les sucreries. Il attrape la canne à sucre par le haut sans terre. Il a une capacité de levage de 1 tonne.",
    image: sugarcaneLoader,
  },
  {
    id: 4,
    title: "Chargeur télescopique",
    description:"Le chargeur télescopique et le déchargeur sont idéaux pour charger et décharger la biomasse comme Husk, Cotton, etc. jusqu'à 17,5 pieds du niveau du sol.",
    image: telescopicLoader,
  },
  {
    id: 5,
    title: "Ultra Chargeur",
    description:"L'ultra-chargeur Bull peut gérer 600 à 800 kg en une seule fois. Il a une hauteur de levage de 15 pieds.",
    image: ultraLoader,
  },
  {
    id: 6,
    title: "v2 Chargeur de canne à sucre",
    description:"Le chargeur de canne à sucre Bull V2 est idéal pour l'industrie sucrière. Il peut supporter 600 à 800 kg en une seule fois. Il a une hauteur de levage de 21 pieds et une hauteur de déchargement / déchargement de 16 pieds. La consommation indicative de diesel du tracteur est de 4 litres maximum par heure dans ladite application.",
    image: v2sugarcane,
  },
  {
    id: 7,
    title: "Chargeur radial",
    description:"Le chargeur radial est une machine de manutention à faible coût, idéale pour les industries de transformation. Il peut être monté sur un tracteur ainsi que sur une plate-forme fixe. Il est utilisé dans la manutention des ordures, le transfert de matériaux perdus tels que des bâtons, des bûches et de la canne à sucre d'une plate-forme à une autre avec une hauteur de levage allant jusqu'à 20 pieds et une capacité de 500 kg.",
    image: linupradialloader,
  },
  {
    id: 8,
    title: "Série agricole",
    description:"L'accessoire de la série BULL Agri est une innovation qui contribue à l'industrie agricole et à la productivité de l'Inde. Il s'agit d'accessoires avec godet polyvalent 6 en 1 avec BAS (Bucket Adaptive system) qui est facilement détachable et attachable du tracteur en 8 à 12 minutes. Il est spécialement conçu pour répondre au travail quotidien des agriculteurs et réduire la dépendance à la main-d'œuvre, ce qui se traduira par une productivité élevée. La série BULL Agri peut être utilisée pour tous les types de manutention de matériel agricole comme le fumier, les céréales, le fourrage, les aliments pour animaux, les produits récoltés, les engrais, les plantations, l'irrigation goutte à goutte (tranchées), l'aménagement des terres, etc.",
    image: agriseries,
  },
];
